import BaseValidator from 'services/validations/base-validator';

class CorrelationStackingBaseValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;

        stacking.getItems().forEach((item) => {
            if (!item.getKeyPlayerId()) {
                this.addError('You should chose a QB player.');
            }

            if (!item.getMinExposure()) {
                this.addError('You should specify min exposure.');
            }

            if (item.getFirstTeamAtLeastPlayers() > item.getFirstTeamAtMostPlayers()) {
                this.addError('"No less than" cannot be "No more than".');
            }

            if (item.getSecondTeamAtLeastPlayers() > item.getSecondTeamAtMostPlayers()) {
                this.addError('"No less than" cannot be "No more than".');
            }
        });
    }
}

export default CorrelationStackingBaseValidator;
